import React, { ReactNode } from "react";
import Header from "./header";
import Footer from "./footer";
import { useLocation } from "react-router-dom";

interface LayoutProps {
  children: ReactNode;
  footerData?: Record<string, any>;
}

const Layout: React.FC<LayoutProps> = ({ footerData, children }) => {
  const location = useLocation();
  const homeHeaderDesignPages = ["/"];
  return (
    <div>
      <Header
        homeHeaderDesign={!!homeHeaderDesignPages.includes(location.pathname)}
      />
      <main className="min-h-[calc(100vh-7.5rem)]">{children}</main>
      <Footer data={footerData} />
    </div>
  );
};

export default Layout;
